module.exports = [
    'a'
  , 'abaft'
  , 'aboard'
  , 'about'
  , 'above'
  , 'absent'
  , 'across'
  , 'afore'
  , 'after'
  , 'against'
  , 'along'
  , 'alongside'
  , 'amid'
  , 'amidst'
  , 'among'
  , 'amongst'
  , 'an'
  , 'apropos'
  , 'apud'
  , 'around'
  , 'as'
  , 'aside'
  , 'astride'
  , 'at'
  , 'athwart'
  , 'atop'
  , 'barring'
  , 'before'
  , 'behind'
  , 'below'
  , 'beneath'
  , 'beside'
  , 'besides'
  , 'between'
  , 'beyond'
  , 'but'
  , 'by'
  , 'circa'
  , 'concerning'
  , 'despite'
  , 'down'
  , 'during'
  , 'except'
  , 'excluding'
  , 'failing'
  , 'following'
  , 'for'
  , 'forenenst'
  , 'from'
  , 'given'
  , 'in'
  , 'including'
  , 'inside'
  , 'into'
  , 'like'
  , 'mid'
  , 'midst'
  , 'minus'
  , 'modulo'
  , 'near'
  , 'next'
  , 'notwithstanding'
  , 'o\''
  , 'of'
  , 'off'
  , 'on'
  , 'onto'
  , 'opposite'
  , 'out'
  , 'outside'
  , 'over'
  , 'pace'
  , 'past'
  , 'per'
  , 'plus'
  , 'pro'
  , 'qua'
  , 'regarding'
  , 'round'
  , 'sans'
  , 'save'
  , 'since'
  , 'than'
  , 'through'
  , 'throughout'
  , 'thru'
  , 'thruout'
  , 'till'
  , 'times'
  , 'to'
  , 'toward'
  , 'towards'
  , 'under'
  , 'underneath'
  , 'unlike'
  , 'until'
  , 'unto'
  , 'up'
  , 'upon'
  , 'versus'
  , 'via'
  , 'vice'
  , 'vis-à-vis'
  , 'with'
  , 'within'
  , 'without'
  , 'worth'
]
